import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import Consejales from '../components/municipalidad/Consejales';

const ConsejoMunicipal = () => (
  <div className='MainMunicipio'>
    <Consejales />

  </div>
);
export default ConsejoMunicipal;
